import { HTMLAttributes } from "react"

export default function ChakraUI(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2332_1861)">
        <path
          d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
          fill="url(#paint0_linear_2332_1861)"
        />
        <path
          d="M35.0849 21.7087C35.131 21.66 35.1618 21.5988 35.1733 21.5327C35.1849 21.4666 35.1768 21.3986 35.15 21.337C35.1233 21.2755 35.079 21.2232 35.0228 21.1866C34.9665 21.15 34.9008 21.1308 34.8337 21.1313H24.3262C23.685 21.1313 23.79 20.7863 24.0187 20.3663C24.2475 19.9425 30.06 9.34125 30.06 9.34125C30.0862 9.285 30.1012 9.22875 30.1012 9.165C30.101 9.08514 30.0773 9.00709 30.033 8.94065C29.9887 8.87421 29.9258 8.82233 29.8521 8.79149C29.7784 8.76066 29.6973 8.75226 29.6189 8.76734C29.5404 8.78242 29.4682 8.8203 29.4112 8.87625L12.9375 25.2937C12.8662 25.3612 12.825 25.4513 12.825 25.5563C12.825 25.755 12.9862 25.9163 13.185 25.9163H24.4237C25.1287 25.9163 24.8774 26.3213 24.7049 26.5575C24.5324 26.7938 16.0237 38.5575 16.0237 38.5575C15.9762 38.6203 15.9472 38.6951 15.9398 38.7735C15.9325 38.852 15.9472 38.9309 15.9823 39.0014C16.0174 39.0719 16.0714 39.1312 16.1383 39.1727C16.2053 39.2142 16.2824 39.2362 16.3612 39.2362C16.4775 39.2362 16.5824 39.1912 16.6574 39.1162C16.7325 39.0412 35.0812 21.7238 35.0812 21.7238L35.0849 21.72L35.0924 21.7125L35.0849 21.7087Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2332_1861"
          x1="24"
          y1="0"
          x2="24"
          y2="48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7ACBD4" />
          <stop offset="1" stopColor="#29C6B7" />
        </linearGradient>
        <clipPath id="clip0_2332_1861">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
